module.exports = __webpack_public_path__ + "static/giggrafter-9fb96d028ce92de7f4e950ec563d32d4.jpeg";